import { number, oneOf, string } from "prop-types";

export default {
  city: string,
  latitude: number,
  longitude: number,
  pretty_address: string,
  state: string,
  street: string,
  unit: string,
  zip: string,
  __typename: oneOf(["Address", "AgentProfileAddress"])
};
